export const downloadCsv = (csv: string, fileName: string) => {
  if (!csv) {
    throw new Error('No csv data');
  }
  const href = `data:application/csv;base64,${csv}`;
  const a = document.createElement('a');
  a.href = href;
  a.download = fileName;
  a.click();
};
